<template>
  <div class="table-responsive">
    <table class="table" style="width: 100%;">
      <thead>
        <tr>
          <th>{{ $t("audit-control.audit.no") }}</th>
          <th>{{ $t("audit-control.audit.name") }}</th>
          <th>{{ $t("audit-control.audit.start-date") }}</th>
          <th>{{ $t("audit-control.audit.end-date") }}</th>
          <th>{{ $t("audit-control.audit.status.text") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="pagination && pagination.docs.length">
        <tr v-for="item in pagination.docs" :key="item._id" class="hider">
          <td class="w-10">{{ item.no }}</td>
          <td>
            <div @click="$router.push({ name: 'organizationAuditDetail', params: { id: item._id } })">{{ item.name | translate }}</div>
          </td>
          <td>
            <div>{{ item.startDate | date }}</div>
          </td>
          <td>
            <div>{{ item.endDate | date }}</div>
          </td>
          <td>
            <div v-if="item.status">{{ $t(`audit-control.audit.status.${item.status.toLowerCase()}`) }}</div>
          </td>
          <td>
            <div class="d-flex" style="gap: 10px;">
              <!-- <i class="iconoir-eye-alt hand" @click="$router.push({ name: 'organizationAuditDetail', params: { id: item._id } })"></i> -->
              <!-- <i class="iconoir-edit hand" @click="$emit('edit', item)"></i> -->
              <i class="iconoir-edit hand" @click="$router.push({ name: 'organizationAuditDetail', params: { id: item._id } })"></i>
              <!-- <i class="iconoir-trash hand" @click="$emit('delete', item._id)"></i> -->
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      // required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
